import React from "react"
import { Callout, Link } from "@node-space/ui-components"
import { PathNames } from "constants/General"
import { useTranslation } from "react-i18next"

export const BeneficiaryDeprecationCallout = ({showAssignNow}: {showAssignNow: boolean}) => {
  const { t } = useTranslation()
  return (
    <Callout variant="warning">
      {t('wallets.fiatSend.beneficiaryLeavingSoonDescription')}
     {showAssignNow && <Link href={PathNames.BANK_BENEFICIARIES} target="_self">
        {t('wallets.fiatSend.assignNow')}
      </Link>}
    </Callout>
  )
}